import { makeRequest } from "../http-common";

const LinesofcoverageDataService = {

    getAll: async function() {
        return makeRequest("get", "/linesofcoverage");
    },

    getById: async function(id) {
        return makeRequest("get", `/linesofcoverage/${id}`);
    },

    update: async function(id, data) {
        return makeRequest("put", `/linesofcoverage/${id}`, data);
    },

    create: async function(data) {
        return makeRequest("post", "/linesofcoverage", data);
    },



}

export default LinesofcoverageDataService;